import Footer from "../../components/Footer"
import Navbar from "../../components/Navbar"
import GroupThree from "../../assets/Images/Home/Group-3.jpg"
import WebLayout from "../../components/WebLayout"

export const LendingPartners = () => {
  return (
    <>
      <WebLayout>
        <div className="home-section flex justify-center items-center min-h-[100vh]">
          <div className="info-section">
            <div className="content-info">
              <h1 className="heading-dark-black">Lending Partner</h1>

              <p className="decription-Lending-partners ">
                Our lending partner, SAFL - NBFC, is an RBI-approved company since 2012. Together, we’re committed to offering dependable financial support for your needs, helping you advance in life with confidence and simplicity
              </p>
            </div>
            <div className="image-info">
              <img src={GroupThree}></img>
            </div>
          </div>
        </div>
      </WebLayout>
    </>
  )
}